export const mBreakPoint = 768
export const lBreakPoint = 1025

export const onlyS = `@media only screen and (max-width: ${mBreakPoint - 1}px)`
export const mUp = `@media only screen and (min-width: ${mBreakPoint}px)`
export const lUp = `@media only screen and (min-width: ${lBreakPoint}px)`
